import { CookbookFilterConfig, SearchOption, SearchQuery } from '../../common';
import { QueryParamsGroups, SearchGroups } from './urlFilters.types';
import { urlFilterParamGroupNames } from './urlFiltersConfig';
import { deserializeUrlParams } from './deserializeUrlParams';

const getSearchGroups = (urlSearchQuery: string): SearchGroups => {
  const searchParams = new URLSearchParams(urlSearchQuery);
  return {
    complexities: searchParams.get(urlFilterParamGroupNames.complexities) || '',
    categories: searchParams.get(urlFilterParamGroupNames.categories) || '',
    texts: searchParams.get(urlFilterParamGroupNames.texts) || '',
  };
};

const getPredefinedFilters = (filtersConfig: CookbookFilterConfig) => ({
  complexities: new Map(Object.keys(filtersConfig.complexity).map((complexity) => [complexity.toLowerCase(), complexity])),
  categories: new Map(filtersConfig.categories.map(({ name }) => [name.toLowerCase(), name])),
});

const prepareSearchQueryFromFilterGroups = (queryParamsGroups: QueryParamsGroups) => {
  const groupToPropertyKey = {
    complexities: 'complexity',
    categories: 'category',
    texts: 'text',
  };
  const searchQuery: SearchQuery = [];

  Object.keys(queryParamsGroups).forEach((queryGroup) => {
    const groupName = queryGroup as keyof QueryParamsGroups;
    const entities = queryParamsGroups[groupName];
    const propName = groupToPropertyKey[groupName];

    if (entities.length) {
      entities.forEach((entity) => {
        searchQuery.push({
          [propName]: entity,
        } as unknown as SearchOption);
      });
    }
  });

  return searchQuery;
};

export const getInitialSearchQuery = (urlSearchQuery: string, filtersConfig: CookbookFilterConfig) => {
  const searchGroups = getSearchGroups(urlSearchQuery);
  const predefinedFilters = getPredefinedFilters(filtersConfig);
  const deserializedUrlFilters = deserializeUrlParams(searchGroups, predefinedFilters);
  return prepareSearchQueryFromFilterGroups(deserializedUrlFilters);
};
